export const AUTOPILOT_COLORS = {
  border: "var(--everlog-card-border)",
  borderSoft: "var(--everlog-card-border-soft)",
  borderFaint: "var(--everlog-card-border-faint)",
  accent: "var(--theme-accent)",
  title: "var(--everlog-card-title)",
  text: "var(--everlog-card-text)",
  muted: "var(--everlog-card-muted)",
  textSoft: "var(--everlog-card-text-soft)",
  textSofter: "var(--everlog-card-text-softer)",
  textFaint: "var(--everlog-card-text-faint)",
  divider: "var(--everlog-card-divider)",
  dividerStrong: "var(--everlog-card-divider-strong)",
  surface: "var(--everlog-card-surface)",
  surfacePill: "var(--everlog-card-surface-pill)",
  insetSurface: "var(--everlog-card-surface-elevated)",
  insetSurfaceActive: "var(--everlog-card-surface-active)",
  statusSuccess: "var(--everlog-status-success)",
  statusDanger: "var(--everlog-status-danger)",
  statusWarning: "var(--everlog-status-warning)",
  statusInfo: "var(--everlog-status-info)",
  statusAccent: "var(--everlog-status-accent)",
  statusNeutral: "var(--everlog-status-neutral)",
  chatBubbleUserBg: "var(--everlog-chat-bubble-user-bg)",
  chatBubbleUserText: "var(--everlog-chat-bubble-user-text)",
  onAccent: "var(--everlog-on-accent-text)",
  chatBubbleAiBg: "var(--everlog-chat-bubble-ai-bg)",
  chatBubbleAiText: "var(--everlog-chat-bubble-ai-text)",
  tooltipBg: "var(--everlog-tooltip-bg)",
  tooltipText: "var(--everlog-tooltip-text)",
  tooltipShadow: "var(--everlog-tooltip-shadow)",
  tooltipBorder: "var(--everlog-tooltip-border)",
  gaugeTrack: "var(--everlog-gauge-track)",
  gaugeDefault: "var(--everlog-gauge-default)",
  purpleBg: "var(--everlog-accent-purple-bg)",
  purpleBorder: "var(--everlog-accent-purple-border)",
  purpleText: "var(--everlog-accent-purple-text)",
  purpleBgHover: "var(--everlog-accent-purple-bg-hover)",
  purpleTextHover: "var(--everlog-accent-purple-text-hover)",
  progressTrack: "var(--everlog-progress-track)",
  infoButtonBg: "var(--everlog-info-button-bg)",
  infoButtonBgDisabled: "var(--everlog-info-button-bg-disabled)",
  infoButtonBorder: "var(--everlog-info-button-border)",
  infoButtonText: "var(--everlog-info-button-text)",
  infoButtonTextSoft: "var(--everlog-info-button-text-soft)",
  infoButtonTextDisabled: "var(--everlog-info-button-text-disabled)",
  statusSuccessBg: "var(--everlog-status-success-bg)",
  statusSuccessBorder: "var(--everlog-status-success-border)",
  statusDangerBg: "var(--everlog-status-danger-bg)",
  statusDangerBorder: "var(--everlog-status-danger-border)",
  // PO1-2724: aliases genéricos para input, cabeçalho de tabela e warning.
  statusWarningBg: "var(--everlog-status-warning-bg)",
  statusWarningBorder: "var(--everlog-status-warning-border)",
  inputBg: "var(--everlog-input-bg)",
  inputBorder: "var(--everlog-input-border)",
  tableHeadBg: "var(--everlog-table-head-bg)",
  tableHeadText: "var(--everlog-table-head-text)",
};

export const autopilotCardStyle = {
  boxShadow: "var(--everlog-card-shadow)",
  border: `1px solid ${AUTOPILOT_COLORS.border}`,
  borderRadius: "var(--everlog-card-radius)",
  overflow: "hidden",
  background: AUTOPILOT_COLORS.surface,
};

export const autopilotHeaderStyle = {
  padding: "1.15rem 1.25rem 0.75rem",
  borderBottom: `1px solid ${AUTOPILOT_COLORS.border}`,
  background: "transparent",
};

export const autopilotBodyStyle = {
  padding: "1rem 1.25rem 1.25rem",
  background: "transparent",
};

export const autopilotEyebrowStyle = {
  color: AUTOPILOT_COLORS.accent,
  fontSize: "0.76rem",
  fontWeight: 700,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  marginBottom: "0.3rem",
};

export const autopilotTitleStyle = {
  color: AUTOPILOT_COLORS.title,
  fontSize: "1.1rem",
  fontWeight: 700,
  marginBottom: "0.25rem",
};

export const autopilotDescriptionStyle = {
  color: AUTOPILOT_COLORS.muted,
  fontSize: "0.84rem",
  lineHeight: 1.5,
  marginBottom: 0,
};

export const autopilotSecondaryButtonStyle = {
  background: "linear-gradient(135deg, var(--theme-accent-surface, var(--theme-accent)), var(--theme-accent-surface-strong, var(--theme-accent-strong)))",
  borderColor: "var(--theme-accent-border)",
  color: "var(--everlog-secondary-btn-text)",
  boxShadow: "var(--everlog-secondary-btn-shadow)",
  fontWeight: 600,
};

export const autopilotInsetCardStyle = {
  border: `1px solid ${AUTOPILOT_COLORS.border}`,
  borderRadius: "14px",
  background: AUTOPILOT_COLORS.insetSurface,
};

export const autopilotInsetDividerStyle = {
  borderBottom: `1px solid ${AUTOPILOT_COLORS.border}`,
};

export const autopilotActionTileStyle = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "0.75rem",
  padding: "0.78rem 0.85rem",
  borderRadius: 12,
  border: `1px solid ${AUTOPILOT_COLORS.border}`,
  background: AUTOPILOT_COLORS.insetSurface,
  color: AUTOPILOT_COLORS.text,
  cursor: "pointer",
  textAlign: "left",
};

// Hero de página (PO1-2724): os mesmos objetos que Auditoria de CT-e e
// Auditoria de Faturas declaravam localmente (`auditHero*Style`). Consumidos
// por `components/PageHero`; manter aqui evita a 4ª cópia.
export const autopilotHeroHeaderStyle = {
  ...autopilotHeaderStyle,
  padding: "1.65rem 1.65rem 1.45rem",
};

export const autopilotHeroEyebrowStyle = {
  ...autopilotEyebrowStyle,
  marginBottom: "0.6rem",
};

export const autopilotHeroTitleStyle = {
  ...autopilotTitleStyle,
  margin: "0 0 0.55rem",
  fontSize: "2rem",
  fontWeight: 800,
  lineHeight: 1.15,
};

export const autopilotHeroDescriptionStyle = {
  ...autopilotDescriptionStyle,
  maxWidth: 820,
  marginBottom: 0,
  fontSize: "0.98rem",
  lineHeight: 1.65,
};
